import React, { useState, useEffect } from "react";
import axios from "axios";
import "./SavedSearchesEditor.css"; // riuso lo stesso stile
import { globals } from '../globals';

export default function SliderEditor() {
  const [slides, setSlides] = useState([]);

  useEffect(() => {
    fetchSlides();
  }, []);

  const fetchSlides = async () => {
    try {
      const response = await axios.get(`${globals.homepageUrl}/php/get-sld-images.php`);
      if (response.data.success) {
        setSlides(response.data.images || []);
      } else {
        setSlides([]);
      }
    } catch (err) {
      console.error("Errore nel caricamento delle slide:", err);
      setSlides([]);
    }
  };

  const handleDelete = async (slide) => {
    if (!window.confirm("Sei sicuro di voler cancellare questa slide?")) return;

    try {
      const response = await axios.post(
        `${globals.homepageUrl}/php/delete-sld-image.php`,
        slide
      );

      if (response.data.success) {
        setSlides((prev) =>
          prev.filter((s) => !(s.folder === slide.folder && s.filename === slide.filename))
        );
      } else {
        alert("Errore durante la cancellazione: " + (response.data.error || "Unknown error"));
      }
    } catch (err) {
      alert("Errore di rete o server durante la cancellazione");
    }
  };

  return (
    <div className="savedsearches-editor-container">
      <h2>Slider Editor</h2>

      <table className="savedsearches-editor-table">
        <thead>
          <tr>
            <th>Preview</th>
            <th>Folder</th>
            <th>Filename</th>
            <th>Actions</th>
          </tr>
        </thead>

        <tbody>
          {slides.map((slide, index) => (
            <tr key={index}>
              <td>
                <img
                  src={`${globals.homepageUrl}/gallery/${slide.folder}/large/${slide.filename}`}
                  alt=""
                  style={{ width: "120px", borderRadius: "6px" }}
                />
              </td>

              <td>{slide.folder}</td>
              <td>{slide.filename}</td>

              <td>
                <button
                  className="savedsearches-delete-button"
                  onClick={() => handleDelete(slide)}
                >
                  Delete
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
